import React, { useState } from 'react';
import styled from 'styled-components';
import { dark_gray, darkest_gray, off_black } from '../../styles/emit-styles/ColorScheme';
import { InfoCardStyled, TRANSITION_LENGTH } from '../../styles/emit-styles/CardStyles';
import { ChartHover } from '../../styles/emit-styles/ChartStyles';

const Value = styled.div`
    font-size: 26px;
    font-weight: 700;
    color: ${off_black};
`;

const Label = styled.div`
    font-size: 20px;
    font-weight: 400;
    color: ${darkest_gray};
    :hover {
        cursor: pointer;
    }
`;

const Caption = styled.div`
    font-size: 16px;
    font-weight: 400;
    color: ${darkest_gray};
`;

const Note = styled.div`
    font-size: 11px;
    font-weight: 400;
    color: ${dark_gray};
`;

const TitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: baseline;
`;

const TooltipContainer = styled(ChartHover)`
    padding: 8px;
    max-width: 250px;
    width: max-content;
    height: auto;
    font-size: 16px;
    position: absolute;
    left: calc(100% + 5px); // Ensure tooltip appears to the right of its parent, with a bit of padding
    // center horizontally with the parent element
    top: 50%; 
    transform: translateY(-50%);

    opacity: ${({ visible }) => visible ? 1 : 0};
    transition: opacity ${TRANSITION_LENGTH} ease;
    pointer-events: ${({ visible }) => visible ? 'auto' : 'none'}; // prevent container from interfering with selection of elements behind it
`;

const TooltipWrapper = styled.div`
    position: relative;
    display: inline-block;
`;


const InfoCard = ({ valuePrefix, value, label, labelHover, caption, subcaption, height, width, minWidth, maxWidth, id }) => {
    const [showHover, setShowHover] = useState(false);

return (
    <InfoCardStyled
        id={id}
        height={height}
        width={width}
        minWidth={minWidth}
        maxWidth={maxWidth}
        disableSelection
        data-testid="info-card-container-testid"
    >
        <Caption id={`${id}-caption`} data-testid="info-card-caption-testid">{caption}</Caption>
        <TitleWrapper id={`${id}-wrapper`}>
            <Value id={`${id}-value`} data-testid="info-card-value-testid">{valuePrefix}{value}</Value>
            {label && (value !== '-') &&
                <TooltipWrapper>
                    <Label
                        id={`${id}-label`}
                        data-testid='info-card-label-testid'
                        onMouseEnter={() => setShowHover(true)}
                        onMouseLeave={() => setShowHover(false)}
                    >
                        {label}
                    </Label>
                    <TooltipContainer visible={showHover}>{labelHover}</TooltipContainer>
                </TooltipWrapper>
            }
        </TitleWrapper>
        {subcaption && <Note id={`${id}-subcaption`} data-testid="info-card-subcaption-testid">{subcaption}</Note>}
    </InfoCardStyled>
    );
};

export default InfoCard;